var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolderLocations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 4,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.875C6 8.37109 7.20312 7.125 8.75 7.125H14.4219C15.2383 7.125 16.0117 7.46875 16.6133 8.07031L18.418 9.875L25.25 9.875C26.7539 9.875 28 11.1211 28 12.625V23.625C28 25.1719 26.7539 26.375 25.25 26.375H8.75C7.20313 26.375 6 25.1719 6 23.625L6 9.875ZM8.75 9.1875C8.36328 9.1875 8.0625 9.53125 8.0625 9.875V23.625C8.0625 24.0117 8.36328 24.3125 8.75 24.3125H25.25C25.5938 24.3125 25.9375 24.0117 25.9375 23.625V12.625C25.9375 12.2812 25.5938 11.9375 25.25 11.9375H18.2891C17.8594 11.9375 17.3867 11.7656 17.0859 11.4648L15.1523 9.48828C14.9375 9.31641 14.6797 9.1875 14.4219 9.1875H8.75Z",
    fill: "#808B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderLocations);
export default __webpack_public_path__ + "static/media/folder-locations.bbb0d99761468cdddccf2a84fd6afd64.svg";
export { ForwardRef as ReactComponent };